module.exports = __webpack_public_path__ + "img/H1.a9a8d4a1.png";